<button class="scroll-top-btn" (click)="scrollToTop()">
  <img alt="" src="./assets/images/arrow_up.png" width="40px" height= "40px">
</button>